// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3eILH","icon":"icon--7hRZK","body":"body--2aq6g"};